export const BLUE = "#2D74BA";
export const DARK_GRAY = "#B7BAC6";
export const GRAY = "#E4E5EB";
export const ORANGE = "#FA541C";
